"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SINGLE_CREDIT_NOTE = void 0;
var SINGLE_CREDIT_NOTE = {
  TEXT__STATUS: 'singleCreditNote-span-status',
  TEXT__OUTLET_NAME: 'singleCreditNote-span-outletName',
  BUTTON__EXPORT_PDF: 'singleCreditNote-button-exportPDF',
  BUTTON__CUSTOMER_INFO: 'singleCreditNote-button-customerInfo',
  CUSTOMER_INFO_MODAL: {
    TEXT__TITLE: 'singleCreditNoteCustomerInfoModal-h3-title',
    BUTTON__EDIT: 'singleCreditNoteCustomerInfoModal-button-edit',
    BUTTON__CLOSE: 'singleCreditNoteCustomerInfoModal-button-close',
    INFO_PANEL: {
      TEXT__PRIMARY_CONTACT_NAME: 'singleCreditNoteCustomerInfoModal-span-primaryContactName',
      TEXT__PRIMARY_CONTACT_PHONE: 'singleCreditNoteCustomerInfoModal-span-primaryContactPhone',
      TEXT__ADDRESS: 'singleCreditNoteCustomerInfoModal-span-address',
      TEXT__CUSTOM_INFO: 'singleCreditNoteCustomerInfoModal-span-customInfo',
      TEXT__EMAIL: 'singleCreditNoteCustomerInfoModal-a-email',
      TEXT__MINIMUM_ORDER_AMOUNT: 'singleCreditNoteCustomerInfoModal-span-minimumOrderAmount',
      TEXT__DELIVERY_FEE: 'singleCreditNoteCustomerInfoModal-span-deliveryFee',
      TEXT__WORKING_HOURS_LABEL: 'singleCreditNoteCustomerInfoModal-span-workingHoursLabel',
      TEXT__WORKING_HOURS: 'singleCreditNoteCustomerInfoModal-span-workingHours',
      TEXT__DELIVERY_PERIOD: 'singleCreditNoteCustomerInfoModal-span-deliveryPeriod',
      TEXT__SHIPPING_ADDRESS: 'singleCreditNoteCustomerInfoModal-span-shippingAddress',
      TEXT__BILLING_ADDRESS: 'singleCreditNoteCustomerInfoModal-span-billingAddress'
    }
  },
  TEXT__CREDIT_NOTE_NUMBER: 'singleCreditNote-span-creditNoteNumber',
  TEXT__ORDER_NUMBER: 'singleCreditNote-span-orderNumber',
  TEXT__CREATED_DATE: 'singleCreditNote-span-createdDate',
  TEXT__WAREHOUSE: 'singleCreditNote-span-warehouse',
  BUTTON__EDIT_WAREHOUSE: 'singleCreditNote-button-editWarehouse',
  BUTTON__ACTION: 'singleCreditNote-button',
  BUTTON__ACTION_MANAGE: 'singleCreditNote-button-manageCreditNote',
  BUTTON__ACTION_SAVE: 'singleCreditNote-button-saveEdit',
  BUTTON__ACTION_DISCARD: 'singleCreditNote-button-discardEdit',
  TEXT__FOOTER_TOTAL: 'singleCreditNote-span-total',
  TEXT__FOOTER_TOTAL_TOOLTIP: 'singleCreditNote-span-totalTooltip'
};
exports.SINGLE_CREDIT_NOTE = SINGLE_CREDIT_NOTE;